import {
    SET_COUNTRIES,
    SET_QUERY_RESULTS,
    SET_COUNTRY,
    SET_REGION,
    SET_COLOR,
    SET_IS_HORIZONTAL_LAYOUT,
    SET_CANVAS_SIZE,
    SET_QUERY,
    ADD_QUERY_RESULT,
    POP_QUERY_RESULT,
    PREVIEW,
    SET_MAP_PRINT_REVIEW_IMAGE_URL, SET_ERROR, SET_ANALYTICS,
} from '../actions/generator';
import timezonesToCountries from '../timezones';
import config from '../config';
import {MAX_SELECTED_CITIES} from '../generatorOptions';

const initialState = {
    mapRequestId: null,
    mapPrintPreview: {
        backgroundImageUrl: config.backgroundImageUrl,
        mapPrintPreviewImageUrl: null,
        mapPrintPreviewFullImageUrl: null,
        x: 0.5,
        y: 0.33,
    },
    showSpinner: false,
    utmParams: [],
    referrer: null,

    countries: [],
    queryResults: [],
    error: null,

    country: null,
    region: null,
    query: '',
    selectedFeatures: [],
    color: {main: "#ffffff", text: "#000000"},
    isHorizontalLayout: false,
    canvasSizeId: 'A2',
    canvasWidth: 4961,
    canvasHeight: 7016,
};


const formatPrice = (country) => {
    if (!country || !country.selling_currency || !country.selling_price) {
        return ""
    }
    let sign = {
        "eur": "€",
        "usd": "$",
        "pln": "zł",
    }[country.selling_currency];
    if (!sign) {
        sign = ""
    }
    return sign + String(country.selling_price / 100);
};


const clearPreview = state => ({
    ...state,
    mapRequestId: null,
    error: null,
    mapPrintPreview: {...state.mapPrintPreview, mapPrintPreviewImageUrl: null, mapPrintPreviewFullImageUrl: null},
});

export const generatorReducer = (state = initialState, action) => {
    const payload = action.payload;

    if (state.showSpinner && [
        SET_COUNTRIES, SET_COUNTRY, SET_REGION, SET_QUERY, ADD_QUERY_RESULT,
        POP_QUERY_RESULT, SET_COLOR, SET_IS_HORIZONTAL_LAYOUT, SET_CANVAS_SIZE, PREVIEW,
    ].includes(action.type)) {
        return state;
    }

    switch (action.type) {
        case SET_COUNTRIES:
            let defaultCountry = payload?.[0] || null;
            let selectedCountry = defaultCountry;
            const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

            if (currentTimezone && payload?.length > 0) {
                const countryCodeByTimezone = timezonesToCountries[currentTimezone];
                if (countryCodeByTimezone) {
                    selectedCountry = payload.find(
                        country => country.iso_alpha_2_code === countryCodeByTimezone
                    ) || defaultCountry;
                }
            }

            return {
                ...clearPreview(state),
                countries: payload,
                region: null,
                selectedFeatures: [],
                country: selectedCountry ? {...selectedCountry, formattedPrice: formatPrice(selectedCountry)} : null
            };
        case SET_QUERY_RESULTS:
            return {...state, queryResults: payload};
        case SET_COUNTRY:
            return {
                ...clearPreview(state),
                country: {...payload, formattedPrice: formatPrice(payload)},
                region: null,
                queryResults: [],
                selectedFeatures: []
            };
        case SET_REGION:
            return {...clearPreview(state), region: payload, queryResults: [], selectedFeatures: []};
        case SET_QUERY:
            return {...state, query: payload || '', queryResults: []};
        case ADD_QUERY_RESULT:
            const isFeatureExists = state.selectedFeatures.some(feature =>
                feature.geometry.coordinates.every((value, index) => value === payload.geometry.coordinates[index])
                && feature.properties.name === payload.properties.name
            );
            if (isFeatureExists || state.selectedFeatures.length >= MAX_SELECTED_CITIES) {
                return state;
            }
            return {...clearPreview(state), selectedFeatures: [...state.selectedFeatures, payload]};
        case POP_QUERY_RESULT:
            return {...clearPreview(state), selectedFeatures: state.selectedFeatures.filter((_, index) => index !== payload)}
        case SET_COLOR:
            return {...clearPreview(state), color: payload};
        case SET_IS_HORIZONTAL_LAYOUT:
            return {...clearPreview(state), isHorizontalLayout: payload};
        case SET_CANVAS_SIZE:
            return {...clearPreview(state), ...payload};
        case PREVIEW:
            return {...clearPreview(state), showSpinner: true};
        case SET_MAP_PRINT_REVIEW_IMAGE_URL:
            return {
                ...state,
                mapRequestId: payload.mapRequestId,
                mapPrintPreview: {
                    ...state.mapPrintPreview,
                    ...payload.mapPrintPreview,
                },
                showSpinner: false
            }
        case SET_ERROR:
            return {...state, error: payload}
        case SET_ANALYTICS:
            return {...state, ...payload}
        default:
            return state;
    }
};
